export const Next = (props) => {
    return (
      <div id='services' className='text-center'>
        <div className='container'>
          <div className='section-title'>
            <h2>Next Step</h2>
          </div>
          <div className='row'>
              <h3>In May 2022, project Carbonet has been published open sourced for any future capstone teams to develope further. </h3>
          </div>
          <div>
              <img src={props.data.img}></img>
          </div>
        </div>
      </div>
    )
}